import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../actions'
import { doTrack } from '../../helpers/TaggingSerializer'

import Svg from '@argos/svg'
import LoadingError from '../../components/LoadingError/LoadingError'
import Sidebar from '../../components/Sidebar/Sidebar'
import Meta from '../../components/Meta/Meta'
import StarRating from '../../components/StarRating/StarRating'
import LiveChat from '../../components/LiveChat/LiveChat'
import SearchBar from '../../components/SearchBar/SearchBar'

import pdfSvg from '../../static/img/product-care/pdf.svg'

import './ProductCare.scss'

class JewelleryCare extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        dispatch(actions.fetchSidebarNav(true)),
        dispatch(actions.fetchPageContent('jewellery-watch-care', true))
      ])
      .then(([sidebar, page]) => {
        if (page.payload.id === 0) {
          res.statusCode = 404
        }
      })
  }

  static waitForDataClient (store) {
    return (nextState, transition, callback) => {
      const { dispatch, getState } = store
      const state = getState()
      const page = state.page.page

      if (page && page.permalink === '/help/jewellery-watch-care/') {
        return callback()
      }

      dispatch(actions.fetchPageContent('jewellery-watch-care'))
        .then(() => { callback() })
        .catch(() => { callback() })
    }
  }

  componentDidMount () {
    const { actions, sidebar } = this.props

    if (!sidebar.length) actions.fetchSidebarNav()
    this.fireAnalytics()
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      window.digitalData.page.pageInfo.pageName = 'ar:help:page:productcare:jewellerycare'
      window.digitalData.page.pageInfo.templateTitle = 'help_PAGE_productcare'
    }

    doTrack('help_initialLoad')
  }

  render () {
    const ccn = 'product-care'
    const { sidebar, page, error } = this.props

    if (!page || error) return <LoadingError />

    return (
      <div className={`${ccn} helpfaq font-standard page`}>
        <div id='helpfaqcontent' tabIndex='-1' />

        <Meta pagemeta={page} />

        <div className='container sticky-nav'>
          <div className='xs-row xs-row--negative lg-row'>
            <Sidebar activePage='/help/jewellery-watch-care/' links={sidebar} sticky />
          </div>
        </div>

        <div className='sticky-content'>
          <div className={'container'}>
            <div className='xs-row'>
              <div className='xs-12 lg-9 lg-3-offset'>
                <div className={`${ccn}-subpage__header ${ccn}-subpage__header--jewellery`}>
                  <h1 className={`${ccn}-subpage__title`}>
                    Jewellery &amp;<br />
                    Watch Care
                  </h1>
                </div>

                <h2 className={`${ccn}__subheading h2`}>Specialist Product care for your most treasured pieces</h2>
                <p>A piece of jewellery or a watch can mean a lot to us and damaging a precious item can be both stressful and upsetting. But with Argos Jewellery &amp; Watch Care, provided by Domestic &amp; General there's less to worry about.</p>
                <p>If it breaks, we'll replace it instantly, so you'll feel like you were never without it. Because if it's important to you, it's important to us!</p>

                <div className={`${ccn}__cover-types-section xs-row xs-row--negative`}>
                  <div className={`${ccn}-cover-type xs-12 md-6`}>
                    <div className={`${ccn}-cover-type__content`}>
                      <div className={`${ccn}-cover-type__title`}>So, what's included?</div>
                      <ul className='list-unstyled list-ticks'>
                        <li>Immediate accidental breakdown cover</li>
                        <li>Theft with force or break-in </li>
                        <li>Instant replacement</li>
                        <li>Breakdown cover after your manufacturer's guarantee ends (watches only)</li>
                      </ul>
                    </div>
                  </div>

                  <div className={`${ccn}-cover-type xs-12 md-6`}>
                    <div className={`${ccn}-cover-type__content`}>
                      <div className={`${ccn}-cover-type__title`}>And what's not included?</div>
                      <ul className='list-unstyled list-cross'>
                        <li>Theft without force, including pickpocketing</li>
                        <li>Loss and deliberate damage</li>
                        <li>The cost of replacing accessories (unless they came with the product originally)</li>
                        <li>Breakdowns covered by another guarantee (watches only)</li>
                        <li>Cosmetic damage that doesn't affect how the item works (watches only)</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='background-color-cerulean text-color-white'>
            <div className={`${ccn}__section ${ccn}__section--details container`}>
              <div className='xs-row'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <p className={`${ccn}__title ${ccn}__title--white`}>Now, for the finer details...</p>

                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12 md-6'>
                      <p>For more information about Argos Jewellery &amp; Watch Care, you can download the Insurance Product Information Document and leaflet below...</p>
                    </div>

                    <div className='xs-12 md-6'>
                      <div className='xs-row xs-row--negative'>
                        <div className={`${ccn}__pdf xs-6`}>
                          <Svg aria-hidden='true'>{pdfSvg}</Svg>
                          <a className={`${ccn}__pdf-link`} href='//documents.4rgos.it/v1/static/690249_IPID' target='_blank'>Download IPID</a>
                        </div>
                        <div className={`${ccn}__pdf xs-6`}>
                          <Svg aria-hidden='true'>{pdfSvg}</Svg>
                          <a className={`${ccn}__pdf-link`} href='//documents.4rgos.it/v1/static/690249_leaflet' target='_blank'>Download Ts&amp;Cs</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${ccn}__section container`}>
            <div className='xs-row'>
              <div className='xs-12 lg-9 lg-3-offset'>
                <h2 className={`${ccn}__subheading h2`}>There's still time... 45 days in fact</h2>
                <div className='xs-row xs-row--negative'>
                  <div className={`${ccn}__45days-image xs-12 md-4`}>
                    <img src='/helpfaq-assets/static/img/product-care/45-days.png' width='110' alt='' />
                  </div>

                  <div className='xs-12 md-8'>
                    <p>Still not quite sure if you want Argos Jewellery &amp; Watch Care? You've got 45 days from the date you buy your item to get that extra reassurance.</p>
                    <p>Just pop into store, with your receipt and one of our friendly colleagues will be happy to help. You can buy it right-then-and-there and you'll be covered right away. Phew, that's a relief!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='background-color-grey-light'>
            <div className={`${ccn}__section ${ccn}__section--claim container`}>
              <div className='xs-row'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <h2 className={`${ccn}__subheading h2`}>Making a claim - we're here for you</h2>
                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12 md-8'>
                      <p>The true test of any insurance is when you need to make a claim. With Argos Jewellery &amp; Watch Care, it couldn't be simpler.</p>
                      <p className='font-bold'>If your item is accidentally damaged or broken:</p>
                      <p>Simply take it into your local Argos store, with the receipt for the item and the Jewellery and Watch Care, and you'll get a replacement.</p>
                      <p>And, don't worry, if we can't swap it for a new one, we'll give you vouchers for the original purchase price of the item.</p>
                      <p>Once you've received a replacement, that's it, your policy has now ended.</p>
                      <p className='font-bold'>If your item has been stolen:</p>
                      <p>In the unfortunate event that your item has been stolen, please report the incident to the Police immediately and request a Crime Reference Number. Then you just need to call us on 0800 561 4488 to make a claim.</p>
                      <p>Please don't go to store as they can only refer to you to the number above.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${ccn}__section container`}>
            <div className='xs-row'>
              <div className='xs-12 lg-9 lg-3-offset'>
                <h2 className={`${ccn}__subheading h2`}>
                  Buy yourself more time with the Argos Card.<br />
                  Representative 29.9% APR Variable
                </h2>
                <div className={`${ccn}__afs-promo xs-row xs-row--negative`}>
                  <div className='xs-12 md-7'>
                    <p>Don't forget you can pay for Product Care with the Argos Card (as well as the item you're actually buying). You even could roll both onto one Buy Now Pay Later plan to spread the cost. Now that's super-smart.</p>
                    <div className={`${ccn}__link--large`}>
                      <a className='button-link button-link--large' href='/help/argos-card/'>Apply for an Argos Card</a>
                    </div>
                    <div className={`${ccn}__link--large`}>
                      <a className='button-link button-link--large' href='/'>Shop now with my Argos Card</a>
                    </div>
                  </div>

                  <div className={`${ccn}__45days-image xs-12 md-5`}>
                    <img src='/helpfaq-assets/static/img/product-care/argos-card.png' width='230' alt='' />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='background-color-grey-light'>
            <div className={`${ccn}__section ${ccn}__section--legal container`}>
              <div className='xs-row'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <p className='font-base--small'>You won't be charged any interest if you pay off your plan within the Pay Later period and keep your account up to date. If you don't pay off your plan before it ends, you'll be charged interest at your normal plan rate from the date of purchase. However, if you choose to make payments without clearing the balance, the earlier you pay the less interest you'll be charged. Credit subject to status.</p>
                  <p className='font-base--small'>Argos Limited is authorised and regulated by the Financial Conduct Authority as a credit broker, and works exclusively with the Argos Card lender, Home Retail Group Card Services Limited.</p>
                  <br />
                  <p className='font-base--small'>Argos Jewellery &amp; Watch Care is provided by Domestic &amp; General Insurance PLC. Registered Office: Swan Court, 11 Worple Road, Wimbledon, London SW19 4JS. Registered in England and Wales. Company No. 485850.</p>
                  <p className='font-base--small'>Domestic &amp; General Insurance PLC is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority.</p>
                </div>
              </div>
            </div>
          </div>

          <div className='container'>
            <div className='xs-row lg-row'>
              <div className='xs-12 lg-9 lg-3-offset'>

                <StarRating pageId={page.id} />

                <LiveChat
                  actions={this.props.actions}
                  chatHasEnded={this.props.chatHasEnded}
                  chatLoading={this.props.chatLoading}
                  chatOnline={this.props.chatOnline}
                />

                <SearchBar position='bottom' />

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

JewelleryCare.propTypes = {
  sidebar: PropTypes.array,
  page: PropTypes.object,
  error: PropTypes.bool,
  actions: PropTypes.object,
  chatHasEnded: PropTypes.bool,
  chatLoading: PropTypes.bool,
  chatOnline: PropTypes.bool
}

function mapStateToProps (state) {
  return {
    sidebar: state.help.sidebar,
    page: state.page.page,
    error: state.page.pageError,
    chatHasEnded: state.page.chatHasEnded,
    chatLoading: state.page.chatLoading,
    chatOnline: state.page.chatOnline
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(JewelleryCare)
